import {useIntl} from "react-intl";
import React, {useEffect, useState} from "react";
import axios from "axios";
import errorParser from "../../../components/ErrorParser/ErrorParser";
import LoadingComp from "../../../components/elements/LoadingComp/LoadingComp";
import {useNavigate} from "react-router-dom";
import ModalGenerateVoucher from "../../../components/ModalGenerateVoucher/ModalGenerateVoucher";
import Button from "../../../components/elements/Button/Button";

export default function Bonus() {

    const intl = useIntl();
    const jwt = localStorage.getItem('jwt')
    const navigate = useNavigate()

    const [bonuses, setBonuses] = useState([])
    const [total, setTotal] = useState(0)
    const [modalGenerateVoucherIsOpen, setModalGenerateVoucherIsOpen] = useState(false)
    const [companySelected, setCompanySelected] = useState(0)
    const [totalForSelectedCompany, setTotalForSelectedCompany] = useState(0)

    const [loading, setLoading] = useState(true)
    useEffect(() => {
        getData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getData = async () => {
        axios.get(process.env.REACT_APP_API + '/bonuses/for-client', {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                setBonuses(response.data.bonuses ?? [])
                setTotal(response.data.total ?? 0)
                setLoading(false)
            })
            .catch(err => {
                errorParser(err, intl)
            })
    }


    if (loading) {
        return <LoadingComp/>
    }

    return (
        <div className="container">

            <div className={"row"}>
                <div className={"col-12"}>
                    <h1 className={"container-title"}>{intl.formatMessage({id: 'general.sidebar.bonus'})}</h1>
                </div>
                <div className={"col-12 pb-4"}>
                    <div className="card">
                        <div className={"header"}>
                            <div className={"row"}>
                                <div className={"col-md-6 col-sm-12"}>
                                    <p>{intl.formatMessage({id: 'general.sidebar.bonus'})}</p>
                                </div>
                                <div className={"col-md-6 col-sm-12"}>
                                    <p style={{float: "right"}}>{parseFloat(total).toFixed(2)} Lei</p>
                                </div>
                            </div>
                        </div>
                        {
                            bonuses.length === 0 ?
                                <div className={"content"}>

                                    <div className={"alert alert-warning"}>{intl.formatMessage({id: 'general.alert_no_bonuses_found'})}</div>
                                </div>
                                :
                                <div className={"content p-0"}>
                                    <div className={"table events-client mb-1"}>

                                        <div className={"table-head"}>
                                            <div className={"row"}>
                                                <div className={"col-2 table-td"}>{intl.formatMessage({id: 'general.nr'})}</div>
                                                <div className={"col-3 table-td"}>{intl.formatMessage({id: 'general.company'})}</div>
                                                <div className={"col-2 table-td"}>{intl.formatMessage({id: 'general.sidebar.bonus'})}</div>
                                                <div className={"col-2 table-td"}>{intl.formatMessage({id: 'general.bonus_left'})}</div>
                                                <div className={"col-3 table-td"}></div>
                                            </div>
                                        </div>

                                        <div className={"table-body"}>
                                            {
                                                bonuses.map((bonus, i) => (
                                                    <div className={"table-row"} key={i}>
                                                        <div className={"row"}>
                                                            <div
                                                                className={"col-2 table-td"}>
                                                                {i+1}
                                                            </div>
                                                            <div
                                                                className={"col-3 table-td"}>
                                                                {bonus.company.title}
                                                            </div>
                                                            <div
                                                                className={"col-2 table-td"}>
                                                                {parseFloat(bonus.value).toFixed(2)}
                                                            </div>
                                                            <div className={"col-2 table-td"} style={{cursor: "pointer"}}
                                                                 onClick={() => navigate('/bonus/' + bonus.company.id)}
                                                            >
                                                                {parseFloat(bonus.change).toFixed(2)}
                                                            </div>
                                                            <div className={"col-3 table-td"}>
                                                                <Button
                                                                    className={"btn-primary mt-2 ms-auto"}
                                                                    value={intl.formatMessage({id: 'general.generate_voucher'})}
                                                                    type={"button"}
                                                                    onClick={() => {
                                                                        setCompanySelected(bonus.company.id)
                                                                        setTotalForSelectedCompany(bonus.change)
                                                                        setModalGenerateVoucherIsOpen(true)
                                                                    }}
                                                                />

                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>
                        }

                        <div className={"footer d-flex justify-content-center"}>
                        </div>
                    </div>
                </div>
            </div>
            <ModalGenerateVoucher modalIsOpen={modalGenerateVoucherIsOpen} setModalIsOpen={setModalGenerateVoucherIsOpen}
            company={companySelected} total={totalForSelectedCompany}/>
        </div>
    );
}

